/**
 * Keeps a cotton-header dropdown/flyout open for a short grace period after the
 * cursor leaves its trigger, so a fast diagonal move toward another item inside
 * the panel doesn't get killed mid-flight by the CSS :hover chain (pointer-events
 * flips to "none" the instant :hover stops matching, even while the panel is
 * still fading out, so the cursor can't "catch" it again once that happens).
 */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const CLOSE_DELAY = 250;
  const triggers = document.querySelectorAll(
    '.cotton-header__menu-item.has-children, .cotton-header__submenu-item.has-children'
  );
  const closeTimers = new WeakMap();

  const closeNow = (trigger) => {
    clearTimeout(closeTimers.get(trigger));
    trigger.classList.remove('is-open');
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => {
      clearTimeout(closeTimers.get(trigger));
      trigger.classList.add('is-open');

      // Only one open submenu per level: closing sibling triggers immediately
      // (no grace period) is what the user actually moved away from.
      if (trigger.parentElement) {
        Array.from(trigger.parentElement.children).forEach((sibling) => {
          if (sibling !== trigger && sibling.classList.contains('is-open')) {
            closeNow(sibling);
          }
        });
      }
    });

    trigger.addEventListener('mouseleave', () => {
      clearTimeout(closeTimers.get(trigger));
      closeTimers.set(
        trigger,
        setTimeout(() => {
          if (!trigger.matches(':hover')) {
            trigger.classList.remove('is-open');
          }
        }, CLOSE_DELAY)
      );
    });
  });
})();
